<template>
 <v-layout
    justify-center
    class="activity"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
  >
    <v-flex
      xs12
      style="padding-bottom: 0px;padding-top: 0px;padding-left: 20px;padding-right: 20px;"
    >
      <div
        style="padding-top: 15px; padding-bottom: 15px;font-size:22px;"
        class="text-center"
        :style="{ 'color': ColorContent}"
      >
        {{ $t(sDay.pre, locale).toUpperCase() }} {{ $t(sDay.month, locale).toUpperCase() }} {{ sDay.pos.toUpperCase() }}
      </div>
      <!-- <div
        style="opacity: 0.8;position: static; height:64px;top:0px;margin-bottom:20px;"
        :style="{ 'background-color': `${BGColor}` }"
      >
        <table border="0" style="width:100%;height:100%;border:0px;" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td" v-for="(day, index) in week" 
              :key="`td${index}`"
              :style="{ 'padding-top': isSimulation || isDesktop ? '20px' : '','background-color': daysToAdd === index ? ColorContent : BGColor, 'border-right': index !== 6 ? '1px solid white' : '0px' }" 
              style="text-align: center;color:white;width:14.19%"
              @click="() => handleAddDays(index)"
            >
              {{ $t(`common.${day}`).substring(0, 2) }}
            </td>
          </tr>
        </table>
      </div> -->
      <div
        style="border-radius:5px;position: static; top:0px;margin-bottom:20px;margin-top:20px;"
        :style="{ 'background-color': `${primaryColor}` }"
      >
        <v-btn-toggle v-model="daysToAdd" style="width: 100%;"
          :style="{ 'background-color': `${secundaryColor}` }"
        >
          <v-btn
            v-for="(day, index) in week"
            :key="`week${index}`"
            style="width:14.3%;min-width:14.2%;"
            :style="{ 'color': secundaryColor }"
            @click="() => handleAddDays(index)"
            :disabled="index === daysToAdd"
            :dark="!isLight(secundaryColor)"
            :light="isLight(secundaryColor)"
          >
            <span :style="{ 'color': isLight(secundaryColor) ? 'black' : 'white' }">{{ $t(`common.${day}Small`, locale).substring(0, 2) }}</span>
           <!-- {{ $t(`common.${day}`).substring(0, 2) }} -->
          </v-btn>          
        </v-btn-toggle>
        <div 
          v-if="!typeOriginalActivity && typesActivity"
          style="padding:20px 20px 0 20px;"
        >
          <v-select
            v-model="typeActivity"
            :items="typesActivity"
            item-text="Name"
            item-value="ID"
            solo
            :value="typeActivity"
            @change="handleChangeTypeActivity"
            :item-color="enterpriseColor"
            :color="enterpriseColor"
          />
        </div>
        <!-- <span
          :style="{ 'color': isLight(primaryColor) ? 'black' : 'white'}"
        >
          <center style="margin-top:10px;padding-bottom:10px;">{{ $t(sDay.pre).toUpperCase() }} {{ $t(sDay.month).toUpperCase() }} {{ sDay.pos.toUpperCase() }}</center>
        </span> -->
      </div>
      <v-container
        fluid
        grid-list-md
        style="padding: 5px"
      >
        <v-layout
          row
          wrap
          style="margin-bottom: 20px;"
        >
          <v-flex
            v-if="!activities || activities.length === 0"
            :style="{ 'background-color': ColorContent, 'color': BGColorContent }"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            {{ $t('activity.messages.noActivities').toUpperCase() }}
          </v-flex>
          <v-flex
            v-for="(activity, index) in activities"
            :key="activity.ID"
            v-bind="{ [`xs${!isSimulation && isDesktop && !isTotem ? 6 : 12}`]: true }"
            style="margin-top: 5px;margin-bottom: 6px;"
            :style="{ 'padding-right': index % 2 === 0 && !isSimulation && isDesktop && !isTotem ? '10px' : '0px', 'padding-left': index % 2 !== 0 && !isSimulation && isDesktop && !isTotem ? '10px' : '0px' }"
          >
            <v-card
            :style="{ 'opacity': activity.Availability.finished ? '0.3' : '1'}"
              style="border-radius:5px;height:100%;"
            >
              <v-layout
                row
                wrap
                style="height:100%;"
              >
                <v-flex
                  xs4
                  style="padding: 0;height:100%;"
                >
                  <v-img
                    :src="activity.Image"
                    :lazy-src="activity.Image"
                    height="100%"
                    width="90%"
                    aspect-ratio="1.7"
                    class="grey lighten-2"
                    style="border-radius: 5px 0 0px 5px;"
                  />
                </v-flex>
                <v-flex
                  :style="{ 'color': colorActivityContent}"
                  xs8
                >
                  <v-layout
                    row
                    wrap
                    style="margin-top:5px;margin-bottom:0px;"
                  >
                    <v-flex
                      xs8
                      style="text-align: left;padding-bottom:5px;line-height:1.2;"
                      :style="{ 'color': titleColor}"
                    >
                      {{ activity.Title.toUpperCase() }}
                    </v-flex>
                    <v-flex
                      xs4
                      style="text-align: right;padding-right: 15px;padding-bottom:0px;"
                    >
                      <add-calendar
                        v-if="!isPI && activity && !activity.Availability.finished && !isTotem"
                        :start="activity.Date"
                        :end="activity.Date"
                        :startTime="activity.TimeStart"
                        :endTime="activity.TimeEnd"
                        :title="activity.Title"
                        :description="activity.Description ? activity.Description : ''"
                        :color="secundaryColor"
                        :active="daysToAdd === 0 && activity.Availability.time"
                        :locale="locale"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      style="text-align: left;padding-top: 0px;padding-bottom: 0px;"
                    >
                      <v-icon
                        :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : descriptionColor}"                  
                        dark
                        class="activity-button"
                        style="margin-left: 0px;font-weight: 500;font-size: 17px;"
                      >
                        mdi-clock-outline
                      </v-icon>
                      <span
                        :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : descriptionColor}"                  
                        style="font-weight: 500;font-size: 17px;"
                      >
                        {{ activity.TimeStart.substring(0, 5) }}-{{ activity.TimeEnd.substring(0, 5) }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs12
                      style="text-align: left;padding-top: 0px;padding-bottom: 7px; padding-right:10px;"
                      :style="{ 'color': `${descriptionColor} !important`}"
                    >
                      <span
                        :style="{ 'opacity': activity.Description && activity.Description.length > 0 ? '1' : '0'}"
                        style="font-size: 13px;line-height: normal;"
                        v-html="activity.Description && activity.Description.length > 0 ? activity.Description : '.'"
                      >
                        <!-- {{ activity.Description && activity.Description.length > 0 ? activity.Description : '.' }} -->
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import tinycolor from 'tinycolor2'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  import AddCalendar from './AddCalendar'
  export default {
    components: {
      AddCalendar
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      typesActivity: null,
      DviewLink: null,
      activities: null,
      daysToAdd: 0,
      week: [],
      typeActivity: 0,
      typeOriginalActivity: null,

      titleColor: null,
      descriptionColor: null,
      primaryColor: null,
      secundaryColor: null,
      colorActivityContent: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      sDate () {
        return `${this.$t(this.sDay.pre, this.locale).toUpperCase()} ${this.$t(this.sDay.month, this.locale).toUpperCase()} ${this.sDay.pos.toUpperCase()}`
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') >= 0 || utils.isTotem()
      },
      sDay () {
        let dToday = new Date()
        const dActual = new Date().setDate(dToday.getDate() + this.daysToAdd)
        const pos = `${new Date(dActual).getDate()}, ${new Date(dActual).getFullYear()}`

        const result = {
          pre: this.daysToAdd === 0 ? 'common.today' : this.daysToAdd === 1 ? 'common.tomorrow' : '',
          month: `common.m${new Date(dActual).getMonth()}`,
          pos
        }
        return result
      }
    },
    watch: {
      locale (v) {
        this.getTypeActivities()
        this.handleGetActivities()
      },
      'data.TypeActivity': {
        handler: function (newValue) {
          this.typeActivity = newValue
          // this.typeOriginalActivity = newValue
          if(newValue >= 0) this.typeOriginalActivity = newValue
          this.handleGetActivities()
        },
        deep: true
      },
      'data.ActivityPrimaryColor': {
        handler: function (newValue) {
          this.checkActivityPrimaryColor()
        },
        deep: true
      },
      'data.ActivitySecundaryColor': {
        handler: function (newValue) {
          this.checkActivitySecundaryColor()
        },
        deep: true
      },
      'data.ActivityColor': {
        handler: function (newValue) {
          this.checkActivityTitleColor()
        },
        deep: true
      },
      'data.ActivityDescriptionColor': {
        handler: function (newValue) {
          this.checkActivityDescriptionColor()
        },
        deep: true
      },
    },
    mounted () {
      this.checkActivityPrimaryColor()
      this.checkActivitySecundaryColor()
      this.checkActivityTitleColor()
      this.checkActivityDescriptionColor()

      this.typeActivity = this.data.TypeActivity ? this.data.TypeActivity : 0
      if(this.typeActivity >= 0) this.typeOriginalActivity = this.typeActivity
      const dSemenaActual = new Date().getUTCDay() - 1
      const aux = []
      for (let i = 0; i < 7; i++) {
        const x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
        aux.push(`s${x}`)
      }
      this.week = aux
      this.getEnterprise()
    },
    methods: {
      getDayLocale (v) {
        let today = new Date()
        const date = new Date(today.setDate(today.getDate() + v))
        console.log(v, date.toLocaleString(this.locale, {weekday: 'long'}) )
        return date.toLocaleString(this.locale, {weekday: 'long'}).substring(0, 2)
      },
      isLight (value) {
        return tinycolor(value).isLight()
      },
      checkActivityPrimaryColor (){
        this.primaryColor = this.data.ActivityPrimaryColor ? this.data.ActivityPrimaryColor : this.BGColor
      },
      checkActivitySecundaryColor (){
        this.secundaryColor = this.data.ActivitySecundaryColor ? this.data.ActivitySecundaryColor : this.BGColorSecundary
      },
      checkActivityTitleColor (){
        this.titleColor = this.data.ActivityColor ? this.data.ActivityColor : this.ColorContent
        this.colorActivityContent = this.data.ActivitySecundaryColor ? this.data.ActivitySecundaryColor : this.ColorContent
      },
      checkActivityDescriptionColor (){
        this.descriptionColor = this.data.ActivityDescriptionColor ? this.data.ActivityDescriptionColor : this.ColorContent
      },
      convertType(ta1) {
        if (ta1.split('#').length === 4) {
          ta1 = ta1.split('#')
          switch (this.locale){
            case 'es':
              ta1 = ta1[0]
              break
            case 'en':
              ta1 = ta1[1]
              break
            case 'du':
              ta1 = ta1[2]
              break
            case 'ca':
              ta1 = ta1[3]
              break
            default:
              ta1 = ta1[1]
              break
          }
        }
        return ta1
      },
      getTypeActivities () {
        axios.get(`https://www.dviewcontent.com/api/p_activity/${this.DviewLink}/dtouch-type-activity`)
          .then(response => {
            let ta1 = response.data[0].TypeActivity01 && response.data[0].TypeActivity01.length > 0 ? response.data[0].TypeActivity01 : 'Type 01'
            ta1 = this.convertType(ta1)
            let ta2 = response.data[0].TypeActivity02 && response.data[0].TypeActivity02.length > 0 ? response.data[0].TypeActivity02 : 'Type 02'
            ta2 = this.convertType(ta2)
            let ta3 = response.data[0].TypeActivity03 && response.data[0].TypeActivity03.length > 0 ? response.data[0].TypeActivity03 : 'Type 03'
            ta3 = this.convertType(ta3)            
            let ta4 = response.data[0].TypeActivity04 && response.data[0].TypeActivity04.length > 0 ? response.data[0].TypeActivity04 : 'Type 04'
            ta4 = this.convertType(ta4)
            let ta5 = response.data[0].TypeActivity05 && response.data[0].TypeActivity05.length > 0 ? response.data[0].TypeActivity05 : 'Type 05'
            ta5 = this.convertType(ta5)


            this.typesActivity = [
              {
                ID: 0,
                Name: this.$t('common.all', this.locale).toUpperCase()
              },
              {
                ID: 1,
                Name: ta1
              },
              {
                ID: 2,
                Name: ta2
              },
              {
                ID: 3,
                Name: ta3
              },
              {
                ID: 4,
                Name: ta4
              },
              {
                ID: 5,
                Name: ta5
              }
            ]
          })
      },
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLink = response.DviewLink
          this.getTypeActivities()
          this.handleGetActivities()
        })
      },
      handleAddDays (value) {
        this.daysToAdd = value
        this.handleGetActivities()
      },
      handleChangeTypeActivity() {
        this.handleGetActivities()
      },
      handleGetActivities () {
        this.activities = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.DviewLink}/dtouch?config=true&daysToAdd=${this.daysToAdd}&type=${this.typeActivity}`)
          .then(response => {
            const aux = response.data && response.data.activities ? response.data.activities : []
            const locale = this.locale === 'ca' ? 'ot' : this.locale
            for (let i = 0; i < aux.length; i++) {
              aux[i].Title = utils.getTranslation(aux[i].Title, locale)
              aux[i].Description = utils.getTranslation(aux[i].Description, locale)
            }
            this.activities = aux
          })
      }
    }
  }
</script>
<style scoped>
  .activity .container {
    padding: 0px;
  }
  .layout.activity.justify-center {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .activity .v-toolbar__content {
    padding: 0px !important;
    margin: auto !important;
  }
  .activity-button {
    margin-left: 10px;
  }
  .activity-button:hover {
    opacity: 0.7;
  }
  .td:hover {
    cursor: pointer;
  }
</style>
